window.EVASuit = window.EVASuit || {};
window.EVASuit.Behaviors = window.EVASuit.Behaviors || {};

window.EVASuit.Behaviors.throttle_single = function() {
    "use strict";
    
    /* Throttle an event handler.
     *
     * Returns a function which, no matter how frequently it's called, will
     * only trigger a maximum of once per timeout period. More specifically,
     * the first event will always be processed, then, no events will process
     * until the end of the timeout period. If one or more events occurred
     * during this period, the last event recieved will trigger immediately
     * after the end of the timeout period, as well as restart the throttling
     * period. Any preceding events will be discarded.
     *
     * Not to be confused with a debounce, which only fires the event handler
     * at the end of a string of events spaced closer than the timeout period.
     *
     * The nature of this function means that any passed in function's return
     * value will be discarded.
     */
    function throttle_single(func, timeout) {
        var lastTimeout, afterLastArgs, afterLastThis;

        function unthrottle() {
            if (afterLastArgs !== undefined) {
                func.apply(afterLastThis, afterLastArgs);
                afterLastArgs = undefined;
                lastTimeout = window.setTimeout(unthrottle, timeout);
            } else {
                lastTimeout = undefined;
            }
        }

        return function () {
            var myThis = this, myArgs = [], i;

            for (i = 0; i < arguments.length; i += 1) {
                myArgs.push(arguments[i]);
            }

            if (lastTimeout === undefined) {
                func.apply(myThis, myArgs);
                lastTimeout = window.setTimeout(unthrottle, timeout);
            } else {
                afterLastArgs = myArgs;
                afterLastThis = myThis;
            }
        };
    }

    return throttle_single;
}();